import React from "react";

export default function PersonalProjectsStarter() {
  return (
    <div className="personal-projects-starter">
      <h1 className="starters-heading-small">Редактор</h1>
    </div>
  );
}
